<template>
  <GfrDropdown class="inline-flex">
    <GfrDropdownTrigger class="text-[#C8CCD3]">
      <IconsUsedName class="h-7 w-7 max-lg:h-8.5 max-lg:w-8.5" />
    </GfrDropdownTrigger>
    <GfrDropdownContent
      :offset-y="8"
      placement="bottom-start"
      wrapper-class="z-20"
      class="flex max-h-38 max-w-96 flex-col overflow-hidden bg-[#2B2D32] pb-2 pt-2 text-[#eee] lg:max-h-24 lg:max-w-56 lg:pt-1"
      @open="resetScroll = true"
    >
      <span class="flex-shrink-0 truncate px-3 text-base text-white max-lg:text-lg-2xl ...">
        {{ formatTransify('UGC_OFFICIAL_WEBSITE_USED_NAME') }}
      </span>
      <GfrScrollArea v-model:reset="resetScroll" class="mt-2 px-3" :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'">
        <ul>
          <li
            v-for="(item, index) in usedNames"
            :key="index"
            class="mb-0.5 flex pl-1 text-xs before:relative before:top-1.5 before:h-1 before:w-1 before:rounded-full before:bg-primary before:content-[''] max-lg:pl-2 max-lg:text-xl max-lg:before:top-3 ltr:before:mr-1 rtl:before:ml-1"
          >
            {{ item }}
          </li>
        </ul>
      </GfrScrollArea>
    </GfrDropdownContent>
  </GfrDropdown>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
defineProps({
  usedNames: {
    type: Array as PropType<string[]>,
    default: () => []
  }
})
const store = useStore()
const { formatTransify } = store
const resetScroll = ref(false)
</script>
